/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import RenderIfVisible from 'react-render-if-visible';

import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TickAnimation from '../tickAnimation';

import { useStyles } from './styles';
import getCommonUIStyles, { getPrimaryButtonColor } from '../../../commons/uiStyles';

function Thumbnail (props) {
    const {
        widget = {},
        data = {},
        label = '',
        widgetTheme = {},
        renderThumbnail = () => {},
        onClick = () => {},
        selected = false,
        view  = 'schedule',
        checkCustomClassName  = 'ecal-schedule-check',
        labelCustomClassName  = 'ecal-schedule-selected',
        thumbnailCustomClassName = 'ecal-calendar-item',
        ...others
    } = props;

    const classes = useStyles({
        widget,
        widgetTheme,
        selected,
        view,
        commonUIStyles: getCommonUIStyles({
            widget,
            widgetTheme,
            view,
        }),
    });

    function getCheckIconColor () {
        return getPrimaryButtonColor(widget);
    }

    function renderCheck () {
        if (!selected) {
            return (<React.Fragment></React.Fragment>);
        }

        return (
            <Grid className={classes.checkOverlay}>
                <TickAnimation className={classNames([classes.check,  checkCustomClassName])} color={getCheckIconColor()} />
            </Grid>
    );
    }

    return (<Grid
                {...others}
                className={classNames([classes.root, labelCustomClassName])}
            >
        <RenderIfVisible rootElementClass={classNames([classes.renderIfVisible])}>
            <Grid className={classes.thumbnail}                   
                onClick={() => {
                        onClick(data);
                    }}
                    >
                <Button
                    disableRipple
                    aria-label="close"
  
                    className={classes.buttonContainer}
                >
                    {renderThumbnail(data)}
                </Button>
                <p
                    variant={'body1'}
                    className={classNames([labelCustomClassName, classes.text])}
                    aria-selected={selected}
                >
                    { label }
                </p>
            </Grid>

            <Grid
                className={classNames([classes.overlay, labelCustomClassName])}
                aria-selected={selected}
            >
                { renderCheck() }
            </Grid>
        </RenderIfVisible>
    </Grid>);
}

Thumbnail.propTypes = {
    data: PropTypes.any,
    widget: PropTypes.any,
    widgetTheme: PropTypes.any,
    label: PropTypes.string,
    renderThumbnail: PropTypes.func,
    onClick: PropTypes.func,
    selected: PropTypes.bool,
    view: PropTypes.string,
    checkCustomClassName: PropTypes.string,
    labelCustomClassName: PropTypes.string,
    thumbnailCustomClassName: PropTypes.string,
};

export default observer(Thumbnail);